import React from 'react';

import Context from '../../../../../../../../context';

import {
  CustomModal,
  UserInformation,
  ResponsiveView,
} from '../../../../../../../../components'

import './index.sass';

type Props = {
  data: any;
}

const ShowInfo: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal } = React.useContext(Context.RejectedParentTransaction);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='aprove-parent-transaction-rejected-show-info-content'>
      <CustomModal maxHeight={'80vh'} maxWidth={'80vw'} open={showModal === 'SHOW_INFO'} onClose={() => setShowModal('NONE')}>
        <ResponsiveView.Row>
          <UserInformation
            name={props?.data?.parent?.firstName + " " + props?.data?.parent?.lastName}
            phoneNumber={props?.data?.parent?.phoneNumber}
            avatar={props?.data?.parent?.avatar}
          />
        </ResponsiveView.Row>
        <hr />
        <img className='image-content' src={props?.data?.paidFishImage} alt={props?.data?.paidFishImage} />
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default ShowInfo;
